import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import NewBreadCrumbs from '../../../@core/components/breadcrumbs/NewBreadCrumbs'
import useFetch from '../../../@core/auth/apiService/useFetch'
import { configGetPuntiVendita } from '../../../@core/auth/apiService/configs'
import { BarChart2 } from 'react-feather'
import { useNavigate } from 'react-router-dom'

const Organization = () => {
    const { data } = useFetch(configGetPuntiVendita())
    const navigate = useNavigate()

    const puntiVendita = data.puntivendita
    if (puntiVendita) return (
        <>
            <NewBreadCrumbs title={'Organizzazione'}></NewBreadCrumbs>
            <div>
                <Row>
                    {puntiVendita.map((e, i) => {
                        return (
                            <Col md='3' key={i} >
                                <Card className='cursor-pointer' style={{ minHeight: '400px', maxHeight: '400px' }} key={i} onClick={() => navigate(`/organization/${e.id}`)}>
                                    <CardBody className='d-flex'>
                                        <Col className='mb-2' xl='12' md='12' sm='12'>
                                            <Row>
                                                <h3 style={{ marginBottom: '0px' }}>{e.nome}</h3>
                                                <h6 style={{ marginBottom: '40px' }}>{e.indirizzo}</h6>
                                            </Row>
                                            <div className="d-flex justify-content-center">
                                                <BarChart2 type='button' size={88} color='#35a3c6'></BarChart2>
                                            </div>

                                            <p><b>Responsabile:</b>  {e.responsabile} </p>
                                            <p><b>Email:</b> {e.email} </p>
                                            <p><b>Recapito:</b> {e.telefono}</p>
                                            <p><b>Altre info:</b> {e.descrizione} </p>
                                        </Col>
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    }
                    )}
                </Row>

            </div>
        </>
    )
}

export default Organization